$(function () {
  $(".tc-blog-v2 .TOC a").on("click", function (e) {
    e.preventDefault();
    var handle = $(this).attr("data-handle");
    var target = $("#" + handle);
    if (target.length) {
      $("html, body").animate(
        { scrollTop: target.offset().top - $("header").outerHeight() - 40 },
        500
      );
    }
  });
});

function tcBlogV2ToggleNav() {
  document.querySelector('.tc-blog-v2 .navbar').classList.toggle('active');
  document.querySelector('.tc-blog-v2 .navbar-list').classList.toggle('active');
  document.querySelector('.tc-blog-v2 .angle').classList.toggle('toggle-up');
}
